import React from 'react';
import LoadingSpinner from './LoadingSpinner';

interface AdminBoxProps {
    contentLoaded?: boolean;
    children: React.ReactNode;
    classString?: string;
    onClick?: (e: any) => void;
}

function AdminBox({ contentLoaded = true, children, classString, onClick }: AdminBoxProps) {
    return (
        <div onClick={onClick ?? onClick} className={`box ${classString}`}>
            {contentLoaded ? (
                <>{children}</>
            ) : (
                <div className="flex justify-center">
                    <LoadingSpinner />
                </div>
            )}
        </div>
    );
}

export default AdminBox;
